// extracted by mini-css-extract-plugin
export default {"RegistryBuilder__Container":"registry-builder__RegistryBuilder__Container__pbtQA","RegistryBuilder__Background":"registry-builder__RegistryBuilder__Background__f1SF7"};